import {
  applicationSchema,
  type Application,
  type ApplicationDecisionInput,
  type ApplicationListQuery,
  type Page,
  type SubmitApplicationInput,
} from '@teentack/shared';
import { apiFetch, post } from '@/lib/api-client';
import { fetchPage } from '@/lib/api-page';

/** The teen's own applications. */
export function fetchMyApplications(
  query: Partial<ApplicationListQuery> = {},
): Promise<Page<Application>> {
  return fetchPage('/applications/me', applicationSchema, query);
}

/** Applications to the poster's own jobs. */
export function fetchJobApplications(
  query: Partial<ApplicationListQuery> = {},
): Promise<Page<Application>> {
  return fetchPage('/applications', applicationSchema, query);
}

export async function submitApplication(input: SubmitApplicationInput): Promise<Application> {
  return applicationSchema.parse(await post<unknown>('/applications', input));
}

export async function decideApplication(
  applicationId: string,
  input: ApplicationDecisionInput,
): Promise<Application> {
  return applicationSchema.parse(
    await post<unknown>(`/applications/${applicationId}/decision`, input),
  );
}

export async function withdrawApplication(applicationId: string): Promise<void> {
  await apiFetch<void>(`/applications/${applicationId}`, { method: 'DELETE' });
}
